export const MappedInputFontWeights = {
  regular: 'regular',
  medium: 'medium',
  semibold: 'semibold',
  bold: 'bold',
};

export const TypographyFontWeights = {
  [MappedInputFontWeights.regular]: 'typography-regular',
  [MappedInputFontWeights.medium]: 'typography-medium',
  [MappedInputFontWeights.semibold]: 'typography-semibold',
  [MappedInputFontWeights.bold]: 'typography-bold',
};

export const MappedInputTags = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6',
  SPAN: 'SPAN',
  P: 'P',
};

export const TypographyTags = {
  [MappedInputTags.H1]: 'h1',
  [MappedInputTags.H2]: 'h2',
  [MappedInputTags.H3]: 'h3',
  [MappedInputTags.H4]: 'h4',
  [MappedInputTags.H5]: 'h5',
  [MappedInputTags.H6]: 'h6',
  [MappedInputTags.SPAN]: 'span',
  [MappedInputTags.P]: 'p',
};

// display variants are meant for h1-h6
export const DisplayVariants = {
  [MappedInputTags.H1]: 'display-2xl',
  [MappedInputTags.H2]: 'display-xl',
  [MappedInputTags.H3]: 'display-lg',
  [MappedInputTags.H4]: 'display-md',
  [MappedInputTags.H5]: 'display-sm',
  [MappedInputTags.H6]: 'display-xs',
};

// Text variants are for informational text, label, buttons etc ui elements
export const MappedInputVariants = {
  xl: 'xl',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs',
};

export const TextVariants = {
  xl: 'text-xl',
  lg: 'text-lg',
  md: 'text-md',
  sm: 'text-sm',
  xs: 'text-xs',
};

export const TypographyVariants = {
  ...DisplayVariants, ...TextVariants,
};

export const MappedInputColors = {
  gray900: 'gray900',
  gray700: 'gray700',
  gray500: 'gray500',
  gray300: 'gray300',
  primary700: 'primary700',
  error700: 'error700',
  error600: 'error600',
  error500: 'error500',
  blue500: 'blue500',
  white: 'white',
};

export const TypographyColors = {
  [MappedInputColors.gray900]: 'typography-gray-900',
  [MappedInputColors.gray700]: 'typography-gray-700',
  [MappedInputColors.gray500]: 'typography-gray-500',
  [MappedInputColors.gray300]: 'typography-gray-300',
  [MappedInputColors.primary700]: 'typography-primary-700',
  [MappedInputColors.error700]: 'typography-error-700',
  [MappedInputColors.error600]: 'typography-error-600',
  [MappedInputColors.error500]: 'typography-error-500',
  [MappedInputColors.blue500]: 'typography-blue-500',
  [MappedInputColors.white]: 'typography-white',
};
